import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { BuildingInfo } from "../building/building.model";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class InfoService {

  buildingsInfo: BuildingInfo[] = [];

  constructor(private http: HttpClient) {}

  getInfo(idBuilding: number) {
    return this.http.get(url + "buildings/" + idBuilding + "/info");
    // return this.focusPark;
  }

  getBuildingForSegments(){
    return this.http.get<BuildingInfo[]>(url + "buildings?info=1");
  }

  async loadBuildingsSegmentsSync(reload: boolean = false) {
    if (this.buildingsInfo.length === 0 || reload) {
      return this.getBuildingForSegments()
        .toPromise()
        .then((list: BuildingInfo[]) => {
          this.buildingsInfo = list;
        });
    }
  }
}
// focusPark = [
  //   {
  //     id: 1,
  //     name: "Opis",
  //     questions: [
  //       {
  //         content: `<table class="resizable-image-container">
  //           <tr>
  //             <td style="margin-top: auto; margin-bottom: auto;">
  //               <p>
  //                 Budynek Sample Warszawa to biurowiec wybudowany w 2000 roku,
  //                 zaprojektowany przez znanych architektów tworzących markę Tuladhane & Adibidez. 
  //                 To obiekt najwyższej klasy A. Budynek jest na tyle ciekawie zaprojektowany, że został
  //                 podzielony na cztery niezależnie działające części. W jego wnętrzu znajduje się wspólne i
  //                 przestronne atrium, oryginalnie kontrastujące z frontem budynku. Wyznacznikiem ciekawej konstrukcji
  //                 tegoż atrium jest pokrycie dachem wykonanym ze szkła i połączenie z efektownym ogrodem zimowym,
  //                 usytuowanym na szóstym piętrze biurowca.
  //               </p>
  //             </td>
  //             <td style="padding: 0;">
  //               <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/biurowiec_w_sercu_warszawy.jpg" alt="" />
  //             </td>
  //           </tr>
  //         </table>`,
  //         id: 1,
  //         idInfoMenu: 1,
  //         title: "Biurowiec w sercu Warszawy",
  //       },
  //       {
  //         content: `<table style="margin: 5px 0;">
  //         <tr>
  //           <td class="icons-padding">
  //             <table >
  //               <tr>
  //                 <td style="width: 14%;">
  //                   <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                     <ion-icon style="vertical-align: middle" size="small" size slot="icon-only" name="calendar"></ion-icon>
  //                   </div>
  //                 </td>
  //                 <td style="width: 86%">
  //                   <h6 style="margin: 5px 0;">Data budowy</h6>
  //                   <p>1998-2001</p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </td>
  //           <td class="icons-padding">
  //             <table>
  //               <tr>
  //                 <td style="width: 14%">
  //                 <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                   <ion-icon size="small" slot="icon-only" name="business-outline"></ion-icon>
  //                 </div>
  //                 </td>
  //                 <td style="width: 86%">
  //                   <h6 style="margin: 5px 0;">Powierzchnia użytkowa</h6>
  //                   <p>62 000m²</p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </td>
  //           <td class="icons-padding">
  //             <table>
  //               <tr>
  //                 <td style="width: 14%">
  //                   <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                     <ion-icon size="small" slot="icon-only" name="code-outline"></ion-icon>
  //                   </div>
  //                 </td>
  //                 <td style="width: 86%">
  //                   <h6 style="margin: 5px 0;">Liczba pięter</h6>
  //                   <p>12</p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </td>
  //         </tr>
  //         <tr>
  //           <td class="icons-padding">
  //             <table>
  //               <tr>
  //                 <td style="width: 14%">
  //                 <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                   <ion-icon size="small" slot="icon-only" name="location-outline"></ion-icon>
  //                 </div>
  //                 </td>
  //                 <td style="width: 86%">
  //                   <h6 style="margin: 5px 0;">Adres</h6>
  //                   <p>
  //                     Biurowiec Sample Aleja Armii Ludowej 26, 00-609
  //                     Warszawa
  //                   </p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </td>
  //           <td class="icons-padding">
  //             <table>
  //               <tr>
  //                 <td style="width: 14%">
  //                   <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                     <ion-icon size="small" slot="icon-only" name="information-circle-outline"></ion-icon>
  //                   </div>
  //                 </td>
  //                 <td style="width: 86%">
  //                   <h6 style="margin: 5px 0;">Lokalizacja</h6>
  //                   <p>
  //                     Budynek Sample zlokalizowany jest przy ul.
  //                     Armii Ludowej 26 w Warszawie, przy Trasie
  //                     Łazienkowskiej (między rondem Jazdy Polskiej a
  //                     Alejami Niepodległości) w okolicach parku Pola
  //                     Mokotowskie.
  //                   </p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </td>
  //           <td class="icons-padding">
  //             <table>
  //               <tr>
  //                 <td style="width: 14%">
  //                   <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                     <ion-icon size="small" slot="icon-only" name="body-outline"></ion-icon>
  //                   </div>
  //                 </td>
  //                 <td style="width: 86%">
  //                   <h6 style="margin: 5px 0;">Architekt</h6>
  //                   <p>
  //                     Zaprojektowany przez architektów z
  //                     warszawskiej pracowni APA Kuryłowicz &
  //                     Associates.
  //                   </p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 2,
  //         idInfoMenu: 2,
  //         title: "Najważniejsze informacje o biurowcu",
  //       },
  //       {
  //         content: `<table  class="resizable-image-container">
  //         <tr>
  //           <td >
  //             <ion-img  src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/biurowiec_uslugi.jpg" alt="" />
  //           </td>
  //           <td style="margin-top: auto; margin-bottom: auto;">
  //             Całość obiektu tworzy 12 kondygnacji naziemnych oraz 3 podziemne.
  //             Powierzchnia typowe piętra wynosi 750 m2. To na poziomach -1 oraz -2 mieszczą się parkingi dostosowane zarówno do aut, jak i rowerów.
  //             Co ciekawe, w tym oryginalnym i nowoczesnym biurowcu znajduje się również myjnia samochodowa oraz nietypowe, bo rzadko występujące w ogóle,
  //             prysznice dla rowerów. W biurowcu funkcjonuje szereg lokali usługowo – handlowych. Są to m.in. restauracja, kawiarnia, club fitness, oddział
  //             Poczty Polskiej, jak i centrum konferencyjne, pozwalające na profesjonalne zorganizowanie zarówno większego, jak i mniejszego spotkania biznesowego.
  //             W obiekcie zastosowano także szereg rozwiązań zwiększających jego ogólną atrakcyjność dla najemców. Mowa o nowoczesnej klimatyzacji, podnoszonych podłogach,
  //             podwieszanych podłogach, pełnym okablowaniu, funkcjonalnym światłowodzie jak i profesjonalnej sieci komputerowej.
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 1,
  //         idInfoMenu: 3,
  //         title: "Biurowiec z szeregiem lokali\xa0usługowo\xa0-\xa0handlowych",
  //       },
  //       {
  //         content: `<table class="gallery-table">
  //         <tr>
  //           <td >
  //             <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/gallery-2.png" alt="" />
  //           </td>
  //           <td align="center" >
  //             <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/gallery-3.png" alt="" />
  //           </td>
  //           <td >
  //             <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/gallery-1.png" alt="" />
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 3,
  //         idInfoMenu: 3,
  //         title: "Galeria zdjęć",
  //       },
  //     ],
  //   },
  //   {
  //     id: 2,
  //     name: "Dla kierowców",
  //     questions: [
  //       {
  //         content: `<table class="resizable-image-container">
  //           <tr>
  //             <td style="margin-top: auto; margin-bottom: auto;">
  //               <p>
  //                 Do dyspozycji naszych najemców mamy parking dwupoziomowy, mieszczący łącznie 450 pojazdów. Na poziomie -1 znajdują się miejsca poszerzone, natomiast na poziomie -2 do dyspozycji najemców i gości są cztery miejsca przeznaczone do ładowania samochodów elektrycznych. 
  //               </p><br /><p>
  //                 Wjazd na parking jest możliwy od strony ul. Lepszej.
  //               </p>
  //               <br />
  //               <p>
  //                 Poniżej znajdują się dokładne wskazówki dojazdu.
  //               </p>
  //             </td>
  //             <td style="padding: 0;">
  //               <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/parking.png" alt="" />
  //             </td>
  //           </tr>
  //         </table>`,
  //         id: 3,
  //         idInfoMenu: 2,
  //         title: "Podziemny parking dla kierowców",
  //       },
  //       {
  //         content: `<section style="margin-top: 8px;>
  //         <div style="display: flex; justify-content: space-between; margin-bottom: 2em; flex-wrap: wrap;">
  //           <h3 >
  //              Wjazd od al. Armii Ludowej
  //           </h3>
  //           <ion-button href="https://www.google.pl/maps/@52.2186779,21.0074364,3a,75y,182.06h,83.2t/data=!3m6!1e1!3m4!1s0cDr9hE2YOtDZbWM6-LlLQ!2e0!7i13312!8i6656?hl=pl">
  //             <span style="color: white" >
  //               Pokaż na mapie
  //             </span>
  //           </ion-button>
  //         </div>
  //         <p style="text-align: center">
  //           <ion-img
  //             src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/wjazdOdAlArmiiLudowej.png"
  //             alt=""/>
  //         </p>
  //       </section>
  //       <section style="margin-top: 8px;">
  //       <div style="display: flex;  justify-content: space-between; margin-bottom: 2em; flex-wrap: wrap;">
  //         <h3 >
  //            Wjazd od strony ul. Filtrowej
  //         </h3>
  //         <ion-button href="https://www.google.pl/maps/@52.2174322,21.0097704,3a,75y,290.08h,90.27t/data=!3m7!1e1!3m5!1sE2g3o_0sjVDuo1nXa4gnvQ!2e0!6shttps:%2F%2Fstreetviewpixels-pa.googleapis.com%2Fv1%2Fthumbnail%3Fpanoid%3DE2g3o_0sjVDuo1nXa4gnvQ%26cb_client%3Dmaps_sv.tactile.gps%26w%3D203%26h%3D100%26yaw%3D342.99017%26pitch%3D0%26thumbfov%3D100!7i13312!8i6656?hl=pl">
  //           <span style="color: white" >
  //             Pokaż na mapie
  //           </span>
  //         </ion-button>
  //       </div>
  //         <p style="text-align: center">
  //           <ion-img
  //             src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/wjazdOdUlFiltrowej.png"
  //             alt=""
  //           />
  //         </p>
  //       </section>`,
  //         id: 5,
  //         idInfoMenu: 2,
  //         title: "Wskazówki dojazdu na parking podziemny",
  //       },
  //     ],
  //   },
  //   {
  //     id: 3,
  //     name: "Dla rowerzystów",
  //     questions: [
  //       {
  //         content: `<table class="resizable-image-container">
  //         <tr>
  //           <td style="margin-top: auto; margin-bottom: auto;">
  //             <p>
  //             Przed budynkiem Sample oraz w garażu podziemnym budynku na kondygnacji -1 oraz -2 znajduje się łącznie ponad 100 miejsc parkingowych dla rowerzystów.</p>
  //             <p> Zwracamy się z prośbą o pozostawianie rowerów wyłącznie w stojakach na rowery oraz o nie zjeżdżanie, tylko sprowadzanie rowerów od miejsca lokalizacji szlabanów do miejsc wyznaczonych dla postoju rowerów w garażu budynku Sample.<p>
  //             <b> Zapraszamy do korzystania ze stojaków na rowery.</b></p>
  //           </td>
  //           <td style="padding: 0;">
  //             <ion-img  src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/bike.png" alt="" />
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "Miejsca parkingowe dla rowerzystów",
  //       },
  //       {
  //         content: `
  //       <section style="margin-top: 8px; text-align: center">
  //         <ion-img
  //           src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/mapkaParking.png"
  //           alt=""
  //         />
  //       </section>`,
  //         id: 5,
  //         idInfoMenu: 2,
  //         title:
  //           "Mapka z lokalizacją stojaków w garażu na kondygnacji (-1) i (-2)",
  //       },
  //     ],
  //   },
  //   {
  //     id: 4,
  //     name: "Dla gości",
  //     questions: [
  //       {
  //         content: `<table class="resizable-image-container">
  //         <tr>
  //           <td style="margin-top: auto; margin-bottom: auto;">
  //              <p>
  //                W budynku znajdują się cztery recepcje (A/B/C/D).
  //               </p>
  //              <p>
  //                 Zaproszeni goście powinni kierować się do urządzeń przy recepcji przypisanej dla danej firmy, gdzie otrzymają kod QR umożliwiający wejście do wind.
  //              </p> <br>
  //           <p>
  //             <table>
  //               <tr>
  //                 <td style="width: 14%">
  //                   <div class="icon" style="margin-top: auto; margin-bottom: auto;">
  //                     <ion-icon size="small" slot="icon-only" name="time-outline"></ion-icon>
  //                   </div>
  //                 </td>
  //                 <td style="width: 89%">
  //                   <h3 style="margin: 5px 0;">Godziny pracy recepcji</h3>
  //                   <p>8:00 - 18:00</p>
  //                 </td>
  //               </tr>
  //             </table>
  //           </p>
  //           </td>
  //           <td style="padding: 0;">
  //             <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/dla_gosci.jpg" alt="" />
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "Informacje dla gości naszego budynku",
  //       },
  //     ],
  //   },
  //   {
  //     id: 5,
  //     name: "Usługi",
  //     questions:[
  //       // {
  //       //   content: `<table>
  //       //   <tr>
  //       //     <td>
  //       //       <p>
  //       //       Budynek Sample posiada bogaty wachlarz niewielkich sklepów i punktów usługowych oraz centrum konferencyjne. Część lokali jest dostępna z poziomu ulicy a do dyspozycji odwiedzających jest również patio, na którym można się zrelaksować, spotkać ze znajomymi lub partnerami biznesowymi.              </p>
  //       //     </td>
  //       //     <td>
  //       //       <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/centrumKonferencyjne.jpg" alt="" ></ion-img>
  //       //     </td>
  //       //   </tr>
  //       // </table>`,
  //       //   id: 6,
  //       //   idInfoMenu: 3,
  //       //   title: "Usługi ",
  //       // },
  //       {
  //         content: `<table>
  //         <tr>
  //           <td style="margin-top: auto; margin-bottom: auto;">
  //             <p>
  //               Administratorem centrum konferencyjnego, mieszczącego się na I piętrze budynku , jest firma EY Academy of Business. Do Państwa dyspozycji są 4 sale konferencyjne. Nasze centrum konferencyjno-szkoleniowe usytuowane jest na I piętrze, w nowoczesnym biurowcu , w samym centrum Warszawy. To cztery profesjonalnie przygotowane sale, świetnie nadające się do organizacji szkoleń, konferencji i innych spotkań.
  //             </p>
  //             <p>
  //               Na terenie budynku znajduje się siłownia Calypso. Polska Sieć Fitness Klubów Calypso S.A. powstała w 2000 roku. Obecnie jest właścicielem 18 klubów zlokalizowanych w takich miastach jak: Warszawa, Gdańsk, Sopot, Częstochowa, Rzeszów, Szczecin, Konin, Elbląg. Do dyspozycji ćwiczących jest powierzchnia 900m2; siłownia 350m2, urządzenia CYBEX; sala fitness 130m2; sala rowerowa 18 stanowisk; sauny suche w szatniach.
  //             </p>
  //             <p>
  //               Do dyspozycji jest również restauracja, która każdego pracującego dnia oferuje świeże produkty dopasowane do większości gustów. Coś dla siebie znajdą mięsożercy, ale i także wegetarianie oraz weganie. Designerskie otoczenie w stylu loftowo - industrialnym uprzyjemni Państwu chwile spędzone przy posiłku.
  //             </p>
  //           </td>
  //           <td style="float: right;">
  //             <ion-img style="width: 100%" src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/uslugi.jpg" alt="" ></ion-img>
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "Centrum Konferencyjne",
  //       },
  //       {
  //         content: `<table>
  //         <tr>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/poczta_pietro.jpg"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Poczta</h3>
  //             <p>
  //               Na parterze znajduje się oddział Poczty Polskiej.
  //             </p>
  //           </td>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/bankomat.jpg"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Bankomat</h3>
  //             <p>
  //               Bankomat czynny 24 godziny na dobę
  //             </p>
  //           </td>
  //         </tr>
  //         <tr>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/defibrylator.jpg"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Defibrylator</h3>
  //             <p>
  //               W celu zapewnienia bezpieczeństwa wszystkim osobom w budynku oraz jego otoczeniu, w Sample zainstalowany został defibrylator.
  //             </p>
  //           </td>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/prysznice.jpg"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Prysznice dla rowerzystów</h3>
  //             <p>
  //               Dla Najemców budynku  dojeżdżających do pracy rowerami zorganizowano w węźle sanitarnym znajdującym się na parterze przy recepcji B prysznice dla Pań i dla Panów.
  //               Serdecznie zapraszamy Państwa do korzystania.
  //             </p>
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "",
  //       },
  //     ],
  //   },
  //   {
  //     id: 6,
  //     name: "Certyfikaty ",
  //     questions: [
  //       {
  //         content: `<table class="resizable-image-container">
  //         <tr>
  //           <td style="margin-top: auto; margin-bottom: auto;">
  //             <p>
  //               Sample to budynek wyposażony w wiele najnowocześniejszych systemów,
  //                które dzięki swojemu działaniu pozwalają najemców i ich gościom w pełni cieszyć się z 
  //                dostępnych przestrzeni oraz rozwiązań, które posiadają najważniejsze certyfikaty.
  //             </p>
  //           </td>
  //           <td>
  //             <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/certyfikaty.jpg" alt=""></ion-img>
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "Certyfikaty posiadane przez nasz budynek",
  //       },
  //       {
  //         content: `<table>
  //         <tr>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/leed.png"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">LEED</h3>
  //             <p>
  //               Certyfikacją zajmuje się operator systemu, USGBC, we
  //               współpracy z GBCI (Green Business Certification
  //               Inc.). Poza granicami Stanów Zjednoczonych proces
  //               ubiegania się o certyfikat wiąże się z koniecznością
  //               współpracy z akredytowanym profesjonalistą (LEED AP)
  //               – konsultantem, bez którego certyfikacja byłaby
  //               technicznie niezwykle utrudniona, a wręcz
  //               niemożliwa. Listę LEED AP można znaleźć na stronie
  //               USGBC.
  //             </p>
  //           </td>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/energy.png"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Energia</h3>
  //             <p>
  //               Świadectwo charakterystyki energetycznej budynku –
  //               termin wprowadzony w polskim ustawodawstwie z dniem
  //               1 stycznia 2009 roku, jako wdrożenie dyrektywy
  //               2002/91/WE Parlamentu Europejskiego i Rady Europy z
  //               16 grudnia 2002 roku, której celem była poprawa
  //               sprawności energetycznej budynków.
  //             </p>
  //           </td>
  //         </tr>
  //         <tr>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img style="mix-blend-mode: darken; height: 263px"
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/light.jpg"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Oświetlenie</h3>
  //             <p>
  //               Uzyskanie certyfikatów wydanych przez prestiżowe
  //               laboratoria dodatkowo potwierdza spełnienie wysokich
  //               wymagań stawianych naszym produktom przez niezależny
  //               podmiot, tak zwaną stronę trzecią. Nadzór organów
  //               certyfikujących wpływa motywująco na procesy
  //               produkcyjne sprawiając, że nasze produkty są
  //               wytwarzane w sposób stabilny i powtarzalny.
  //             </p>
  //           </td>
  //           <td>
  //             <section style="text-align: center">
  //               <ion-img
  //                 src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/water.png"
  //                 alt=""
  //               ></ion-img>
  //             </section>
  //             <h3 style="text-align: center; margin-bottom: 1em; margin-top: 20px">Woda</h3>
  //             <p>
  //               Na każdym piętrze budynku znajduje się dystrybutor w
  //               wodą. W każdym pomieszczeniu sanitarnym znajduje się
  //               urządzenie filtrujące klasy A23.
  //             </p>
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "",
  //       },
  //     ],
  //   },
  //   {
  //     id: 7,
  //     name: "Plan ewakuacji",
  //     questions: [
  //       // {
  //       //   content: `<table>
  //       //   <tr>
  //       //     <td>
  //       //       <ion-img src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/evacuation.png" alt="" />
  //       //     </td>
  //       //   </tr>
  //       // </table>`,
  //       //   id: 6,
  //       //   idInfoMenu: 3,
  //       //   title: "Szczegółowy plan ewakuacji budynku",
  //       // },
  //       {
  //         content: `
  //         <section style="text-align: center">
  //             <ion-img
  //             src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/evacuation-plan.png"
  //             alt=""
  //           ></ion-img>
  //         </section>
  //         `,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: '',
  //       },
  //     ],
  //   },
  //   {
  //     id: 8,
  //     name: "Kontakt",
  //     questions: [
  //       {
  //         content: `<table class="contact-container">
  //         <tr>
  //           <td style="margin-top: auto; margin-bottom: auto;">
  //             <h3>Ochrona</h3>
  //             <img style="margin: 5px" src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/telefon.svg">
  //             <a href="tel:222607774">22 260 77 74</a>

  //             <h3>Zarządca budynki</h3>
  //             <img style="margin: 5px" src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/telefon.svg">
  //             <a href="tel:223423285">22 342 32 85</a>

  //             <h3>Wynajem powierzchni</h3>
  //             <img style="margin: 5px" src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/telefon.svg">
  //             <a href="tel:225799725">22 579 97 25</a>

  //             <h3>Wynajem sal konferencyjnych</h3>
  //             <img style="margin: 5px" src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/telefon.svg">
  //             <a href="tel:504112787">504 112 787</a>
  //             <br />
  //             <img style="margin: 5px" src="https://virtualreceptionfiles.blob.core.windows.net/assets/demo/email.svg">
  //             <a href="mailto:booking@sample.pl">booking@sample.pl</a>
  //           </td>
  //           <td style="display: flex; justify-content: flex-end">
  //             <ion-img  src="https://virtualreceptionfiles.blob.core.windows.net/assets/focus/contact.png" alt="" />
  //           </td>
  //         </tr>
  //       </table>`,
  //         id: 6,
  //         idInfoMenu: 3,
  //         title: "Najważniejsze dane kontaktowe",
  //       },
  //     ],
  //   },
  // ];
  